import React from 'react';
import dayjs from 'dayjs';
import { DateFormats } from '@lanterds/types';
import { CONTACT_SUPPORT_MESSAGE, GENERAL_ERROR_MESSAGE, SupportEmail } from 'src/util/constants';
import './EmbeddedError.scss';

export default function EmbeddedError({
    message,
    errorCode,
    showContactSupport = false,
}: {
    message?: string;
    errorCode: string;
    showContactSupport?: boolean;
}) {
    const today = dayjs().format(DateFormats.ShortDateTime);
    const href = `mailto:${SupportEmail}?subject=Parcel%20Search%Issue?body=URL:%20${window.location.href};%20Time:%20${today}`;
    // Allows the message param to be an empty string and will use the general error message
    const errorMessage = message ? message : GENERAL_ERROR_MESSAGE;

    console.error({ errorMessage, errorCode });

    return (
        <div className="error-container">
            <div className="error-message-text">{errorMessage}</div>
            {showContactSupport && (
                <div className="error-support-text">
                    {CONTACT_SUPPORT_MESSAGE}
                    <a href={href} target="_blank" rel="noreferrer">
                        {SupportEmail}
                    </a>
                </div>
            )}
        </div>
    );
}
